import { render, staticRenderFns } from "./LowBalancePage.vue?vue&type=template&id=4dd21c4e"
import script from "./LowBalancePage.vue?vue&type=script&lang=js"
export * from "./LowBalancePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports